export const trainStationsData = {
  Mumbai: [
    { id: 1, name: 'Mumbai Central', locality: 'Mumbai Central', city: 'Mumbai', coordinates: [72.8235, 18.9676] },
    { id: 2, name: 'Mumbai Dadar', locality: 'Dadar', city: 'Mumbai', coordinates: [72.8243, 19.0176] },
    { id: 3, name: 'Lower Parel', locality: 'Lower Parel', city: 'Mumbai', coordinates: [72.8252, 19.0042] },
    { id: 4, name: 'Bandra', locality: 'Bandra', city: 'Mumbai', coordinates: [72.8325, 19.0596] },
    { id: 5, name: 'Thane', locality: 'Thane', city: 'Mumbai', coordinates: [72.9781, 19.2183] },
    { id: 6, name: 'Kurla', locality: 'Kurla', city: 'Mumbai', coordinates: [72.8689, 19.0721] },
    { id: 7, name: 'Borivali', locality: 'Borivali', city: 'Mumbai', coordinates: [72.8115, 19.2298] },
    { id: 8, name: 'Malad', locality: 'Malad', city: 'Mumbai', coordinates: [72.8406, 19.1848] },
    { id: 9, name: 'Andheri', locality: 'Andheri', city: 'Mumbai', coordinates: [72.8479, 19.1136] },
    { id: 10, name: 'Powai', locality: 'Powai', city: 'Mumbai', coordinates: [72.9050, 19.1136] },
  ],
  Delhi: [
    { id: 11, name: 'Delhi Central', locality: 'New Delhi', city: 'Delhi', coordinates: [77.2273, 28.6431] },
    { id: 12, name: 'Delhi Airport', locality: 'Indira Gandhi International Airport', city: 'Delhi', coordinates: [77.1025, 28.5562] },
    { id: 13, name: 'Old Delhi', locality: 'Old Delhi', city: 'Delhi', coordinates: [77.2273, 28.6508] },
  ],
  Bangalore: [
    { id: 14, name: 'Bangalore City', locality: 'Bangalore City', city: 'Bangalore', coordinates: [77.5710, 12.9716] },
    { id: 15, name: 'Yeshwantpur', locality: 'Yeshwantpur', city: 'Bangalore', coordinates: [77.5737, 13.0039] },
  ],
  Chennai: [
    { id: 16, name: 'Chennai Central', locality: 'Chennai Central', city: 'Chennai', coordinates: [80.2707, 13.0827] },
    { id: 17, name: 'Egmore', locality: 'Egmore', city: 'Chennai', coordinates: [80.2618, 13.1005] },
  ],
  Kolkata: [
    { id: 18, name: 'Kolkata Central', locality: 'Kolkata Central', city: 'Kolkata', coordinates: [88.3639, 22.5431] },
    { id: 19, name: 'Sealdah', locality: 'Sealdah', city: 'Kolkata', coordinates: [88.3750, 22.5503] },
  ],
};

export const getAllTrainStations = () => {
  return Object.values(trainStationsData).flat();
};

export const getTrainStationsByCity = (city) => {
  return trainStationsData[city] || [];
};

export const findNearestTrainStation = (latitude, longitude, city = 'Mumbai') => {
  const stations = getTrainStationsByCity(city);
  if (stations.length === 0) return null;

  let nearest = stations[0];
  let minDistance = Infinity;

  stations.forEach(station => {
    const [stationLon, stationLat] = station.coordinates;
    const distance = Math.sqrt(
      Math.pow(latitude - stationLat, 2) + Math.pow(longitude - stationLon, 2)
    );
    if (distance < minDistance) {
      minDistance = distance;
      nearest = station;
    }
  });

  // If distance is less than 0.05 degrees (roughly 5km), return the station
  if (minDistance < 0.05) {
    return nearest;
  }
  return null;
};
